import { useBranding } from "../context/BrandingContext";
import { LaundryMark } from "./LaundryMark";

/**
 * The owner's uploaded logo, falling back to the brand mark.
 *
 * `object-contain` with a max height rather than a fixed box, and never a
 * border-radius: an owner's logo has its own aspect ratio and its own edges, and
 * cropping or rounding it damages a mark they chose deliberately.
 */
export function BrandLogo({ size = 40, className = "" }: { size?: number; className?: string }) {
  const { branding, appName } = useBranding();

  if (branding.logoUrl) {
    return (
      <img
        src={branding.logoUrl}
        alt={appName}
        className={`object-contain ${className}`}
        style={{ maxHeight: size, maxWidth: size * 4 }}
      />
    );
  }

  return <LaundryMark size={size} className={className} />;
}
